import React, { useState } from "react";
import ImageLoading from "../../components/ImageLoading";
import NoDataFound from "../../components/NoDataFound";
import StockAnalyzer from "./StockAnalyzer";
import MutualFundAnalyzer from "./MutualFundAnalyzer";
import RealEstateAnalyzer from "./RealEstateAnalyzer";
import VehicleAnalyzer from "./VehicleAnalyzer";
import AssetGateway from "./AssetGateway";
import ConsentSummaryHistory from "./ConsentSummaryHistory";

function GatewayItems({ flag, id, refreshRender }) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);

  return (
    <>
      {loading && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <ImageLoading />
        </div>
      )}
      {noData && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <NoDataFound />
        </div>
      )}
      {!loading &&
        !noData &&
        (flag === "Reports" ? (
          <AssetGateway id={id} refreshRender={refreshRender} />
        ) : flag === "Consent Summary History" ? (
          <ConsentSummaryHistory id={id} />
        ) : (
          <div></div>
        ))}
    </>
  );
}

export default GatewayItems;
